import { httpClient } from "@services/api/httpClient";

const resendApplicantCode = async (offerId: number, email: string, language: string) => {
    const response = await httpClient.post("/offer-applicant/resend-code", {
        offerId,
        email,
        language,
    });
    return response.data;
};

export default resendApplicantCode;
